/**
 * @generated SignedSource<<8ad255f0e7a73e506b252f252aa30ae0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SignalPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type WorkspaceSignalStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalListItem_signal$data = {
  readonly id: string;
  readonly isWorkspaceOwner: boolean;
  readonly priority: SignalPriority;
  readonly publishedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly scheduledPublishAt: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly status: WorkspaceSignalStatus;
  readonly topic: {
    readonly name: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalListItemDescription_signal">;
  readonly " $fragmentType": "WorkspaceSignalListItem_signal";
};
export type WorkspaceSignalListItem_signal$key = {
  readonly " $data"?: WorkspaceSignalListItem_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalListItem_signal">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "FormattedDate"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalListItem_signal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "workspaceId",
          "variableName": "workspaceId"
        }
      ],
      "kind": "ScalarField",
      "name": "isWorkspaceOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "publishedAtDate",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "scheduledPublishAt",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "topic",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceSignalListItemDescription_signal"
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "6417214806db9f46c3cdca30d18b6f44";

export default node;
